import CssBaseline from '@material-ui/core/CssBaseline';
import { responsiveFontSizes, ThemeProvider, unstable_createMuiStrictModeTheme as createMuiTheme } from '@material-ui/core/styles';
import { SnackbarProvider } from 'notistack';
import React from 'react';
import {
  BrowserRouter as Router, Redirect, Route, Switch,
} from 'react-router-dom';
import './App.css';
import Authentication from './components/Authentication';
import EngineerProvider from './components/EngineerProvider';
import Footer from './components/Footer';
import Header from './components/Header';
import Home from './components/Home';
import Jobs from './components/Jobs';
import ActiveJobs from './components/Jobs/Active';
import PotentialJobs from './components/Jobs/Potential';
import LoadingPage from './components/Loading/Page';
import PrivateRoute from './components/PrivateRoute';
import Profile from './components/profile';
import SignIn from './components/SignIn';
import { TypistSpeedProvider } from './components/Typist';
import UTMParamsProcessor from './components/UTMParamsProcessor';
import Welcome from './components/Welcome';
import WelcomeFinishSignup from './components/Welcome/FinishSignup';
import WelcomeSuccess from './components/Welcome/Success';
import routes from './routes';

let theme = createMuiTheme({
  typography: {
    fontFamily: [
      'Inter',
      'sans-serif',
    ].join(','),
  },
  palette: {
    primary: {
      main: '#6474ff',
    },
    secondary: {
      main: '#e17269',
    },
  },
});

theme = responsiveFontSizes(theme);

function App() {
  return (
    <ThemeProvider theme={theme}>
      <SnackbarProvider>
        <Router>
          <UTMParamsProcessor />
          <Authentication>
            <EngineerProvider>
              <TypistSpeedProvider>
                <CssBaseline />
                <Header />
                <Switch>
                  <Route path={routes.signIn}>
                    <SignIn />
                  </Route>
                  <Route path={routes.signOut}>
                    <Redirect to={routes.home} />
                  </Route>
                  <Route path={routes.signOutCallback}>
                    <Redirect to={routes.home} />
                  </Route>
                  <Route path={routes.welcome.finishSignup}>
                    <WelcomeFinishSignup />
                  </Route>
                  <Route path={routes.welcome.success}>
                    <WelcomeSuccess />
                  </Route>
                  <Route path={routes.welcome.withPage}>
                    <Welcome />
                  </Route>
                  <Route path={routes.welcome.root}>
                    <Welcome />
                  </Route>
                  <Route path={routes.signInCallback}>
                    <LoadingPage />
                  </Route>
                  <Route path={routes.home} exact>
                    <Home />
                  </Route>
                  <PrivateRoute>
                    <Switch>
                      <Route path={routes.jobs.active}>
                        <ActiveJobs />
                      </Route>
                      <Route path={[routes.jobs.potentialMarkInterest, routes.jobs.potential]}>
                        <PotentialJobs />
                      </Route>
                      <Route path={routes.jobs.root}>
                        <Jobs />
                      </Route>
                      <Route path={routes.profile.root}>
                        <Profile />
                      </Route>
                    </Switch>
                  </PrivateRoute>
                </Switch>
                <Footer />
              </TypistSpeedProvider>
            </EngineerProvider>
          </Authentication>
        </Router>
      </SnackbarProvider>
    </ThemeProvider>
  );
}

export default App;
